import React from "react";
import classes from "./Footer.module.css";
import { Logo } from "../../Components/index";
import { Link } from "react-router-dom";

// Icons
import FacebookIcon from "../../assets/icons/facebook-logo.svg";
import TwitterIcon from "../../assets/icons/twitter-logo.svg";
import LinkedinIcon from "../../assets/icons/linkedin-logo.svg";
import TelegramIcon from "../../assets/icons/telegram-logo.svg";
import PhoneIcon from "../../assets/icons/phone-call.svg";
import EmailIcon from "../../assets/icons/envelope-simple.svg";

function Footer() {
  return (
    <footer className={classes.Footer}>
      <Logo />

      <div className={classes.FooterContent}>
        <div>
          <p className={classes.FooterHeading}>Important Link</p>
          <ul className={classes.FooterList}>
            <Link className={classes.FooterListLink} to="/aboutus">
              About
            </Link>
            <Link className={classes.FooterListLink} to="/contactus">
              Contact
            </Link>
            <Link className={classes.FooterListLink} to="/services">
              Services
            </Link>
          </ul>
        </div>

        <div>
          <p className={classes.FooterHeading}>Communication</p>
          <ul className={classes.FooterList}>
            <a
              className={classes.FooterListLink}
              href="mailto:africanhub@gmail.com"
              target="/"
            >
              <img
                className={classes.FooterListIcon}
                src={EmailIcon}
                alt="Envelope Icon"
              />
              @allafricanhub.com
            </a>
            <a
              className={classes.FooterListLink}
              href="tel:+251974760227"
              target="/"
            >
              <img
                className={classes.FooterListIcon}
                src={PhoneIcon}
                alt="Phone Call Icon"
              />
              +251 974760227
            </a>
            <a
              className={classes.FooterListLink}
              href="https://facebook.com"
              target="/"
            >
              <img
                className={classes.FooterListIcon}
                src={FacebookIcon}
                alt="Facebook Logo"
              />
              @allafricanhub
            </a>
            <a
              className={classes.FooterListLink}
              href="https://twitter.com"
              target="/"
            >
              <img
                className={classes.FooterListIcon}
                src={TwitterIcon}
                alt="Twitter Logo"
              />
              @allafricanhub
            </a>
            <a
              className={classes.FooterListLink}
              href="https://linkedin.com"
              target="/"
            >
              <img
                className={classes.FooterListIcon}
                src={LinkedinIcon}
                alt="Linkedin Logo"
              />
              @allafricanhub
            </a>
            <a
              className={classes.FooterListLink}
              href="https://telegram.com"
              target="/"
            >
              <img
                className={classes.FooterListIcon}
                src={TelegramIcon}
                alt="Telegram Logo"
              />
              @allafricanhub
            </a>
          </ul>
        </div>

        <div className={classes.FooterLocation}>
          <p className={classes.FooterHeading}>Location</p>
          <p className={classes.Location}>Addis Ababa, Ethiopia</p>
        </div>
      </div>
      <p className={classes.copyright}>
        &copy; 2022 All african Hub. All right Reserved.
      </p>
    </footer>
  );
}

export default Footer;
